export default "__VITE_ASSET__cmXSKklh__"